
import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, Getter, State } from "vuex-class";
import Tool from "@/models/tool";
import Job from "@/models/job";
import Honor from "@/models/honor";
import Study from "@/models/study";
import Language from "@/models/language";
import FlatLoader from "@/components/FlatLoader.vue";
import Stars from "@/components/Stars.vue";
import AboutHeader from "@/components/AboutHeader.vue";

const namespace = "CVModule";

@Component({
  components: {
    FlatLoader,
    Stars,
    AboutHeader
  }
})

export default class CV extends Vue{
  @Action('fetchData', { namespace }) private fetchData!: () => any;
  @Getter('getGraphicDesignTools', { namespace }) private graphicDesignTools!: () => Tool[];
  @Getter('getSoundTools', { namespace }) private soundTools!: () => Tool[];
  @Getter('getWebDevelopmentTools', { namespace }) private webDevelopmentTools!: () => Tool[];
  @Getter('getSoftwareDevelopmentTools', { namespace }) private softwareDevelopmentTools!: () => Tool[];
  @Getter('getGenerativeArtTools', { namespace }) private generativeArtTools!: () => Tool[];
  @Getter('get3DTools', { namespace }) private threeDTools!: () => Tool[];
  @Getter('getVideoTools', { namespace }) private videoTools!: () => Tool[];
  @Getter('getWebDesignTools', { namespace }) private webDesignTools!: () => Tool[];
  @Getter('getARTools', { namespace }) private ARTools!: () => Tool[];
  @Getter('getMobileDevelopmentTools', { namespace }) private mobileDevelopmentTools!: () => Tool[];
  @Mutation('setDisplayingSection', {namespace}) private setDisplayingSection!: (value:string) => any;
  @State('toolkit', { namespace }) private toolkit!: () => Tool[];
  @State('jobs', { namespace }) private jobs!: () => Job[];
  @State('honors', { namespace }) private honors!: () => Honor[];
  @State('studies', { namespace }) private studies!: () => Study[];
  @State('languages', { namespace }) private languages!: () => Language[];
  @State('loading', { namespace }) private loading!: () => boolean;
  @State('displayingSection', { namespace }) private displayingSection!: () => string;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }

  private async created(){
    await this.fetchData();
  }

  private handleMenuClick(value:string){
    this.setDisplayingSection(value);
  }
 
};
